"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSelfPrimingOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm0 2a12 12 0 0111.94 10.84 4.49 4.49 0 01-1.27.75c-1.14.4-2.28.05-3.49-1.07l-.68-.63-.68.63c-1.78 1.64-3.36 1.64-5.14 0l-.68-.63-.68.63c-1.78 1.64-3.36 1.64-5.14 0l-.68-.63-.68.63C7.61 15.64 6.47 16 5.33 15.59a4.49 4.49 0 01-1.27-.75A12 12 0 0116 4zm0 24A12 12 0 014.06 17.21a4.66 4.66 0 00.61.26 5 5 0 004.83-.92 5 5 0 006.5 0 5 5 0 006.5 0 5.35 5.35 0 003.24 1.21 5.14 5.14 0 002.2-.55A12 12 0 0116 28z" }),
        React.createElement("path", { d: "M16 9a6.9 6.9 0 013.77 1.1l-2.18 1 .82 1.82 5-2.25-1-1a9 9 0 00-12.72 0l1.41 1.41A7 7 0 0116 9zM16 23a6.9 6.9 0 01-3.77-1.1l2.18-1-.82-1.82-5 2.25 1 1a9 9 0 0012.72 0L21 21a7 7 0 01-5 2z" })));
}
exports.default = SvgSelfPrimingOutline;
//# sourceMappingURL=SelfPrimingOutline.js.map